import React, { useEffect } from 'react'
import { Outlet, Route, Routes, Navigate } from 'react-router-dom'
import Header from '../../views/layout/Header'
import Sidebar from '../../views/layout/Sidebar'
import News from '../../views/pages/News/News'
import Addnews from '../../views/pages/AddNewspage/Addnews'
// import GetInTouch from "../../views/pages/GetInTouch/getInTouch";
import UserList from '../../views/pages/UsersList/usersList'
import FAQ from "../../views/pages/FAQ/FAQS";
// import AddFaqs from "../../views/pages/FAQ/addFaqs";
// import FAQ from "../../views/pages/FAQ/FAQS";
import AddFaqs from "../../views/pages/FAQ/addFaqs";
import ProfileInformation from '../../views/pages/ProfileInformationPage/profileInformation'
// import AddDocuments from '../../views/pages/Documents/addDocuments'
import UserDetails from '../../views/pages/UsersList/userDetails'
// import SupportDetails from "../../views/pages/GetInTouch/getInTouchDetails";
// import Products from "../../views/pages/Products/products";
// import AddProducts from "../../views/pages/Products/addProducts";
// import ProductDetails from "../../views/pages/Products/productDetails";
// import InviteFriend from "../../views/pages/Invitefriend/invitefriend";
// import Documents from '../../views/pages/Documents/Documents'
import Subscriptions from '../../views/pages/Subscriptions/subscriptions'
import SubscriptionDetails from '../../views/pages/Subscriptions/subscriptionsDetails'
import Broker from '../../views/pages/Brokers/brokers'
import AddBrokers from '../../views/pages/Brokers/addBrokers'

import Payments from '../../views/pages/Payment/Payment'
import Dashboard from '../../views/pages/Dashboard/DashboardMain'
import AddNotification from '../../views/pages/Notifications/AddNotification'
import NotificationList from '../../views/pages/Notifications/NotificationList'
import Coins from '../../views/pages/Coins/Coins'
import AddCoins from '../../views/pages/Coins/AddCoins' //main coins/Points
import DatesDairies from '../../views/pages/DatesForYourDairies/DatesDairies'
import AddDatesDairies from '../../views/pages/DatesForYourDairies/AddDatesDairies'
import Category from '../../views/pages/Category/Category'
import AddCategory from '../../views/pages/Category/AddCategory'
import Locations from '../../views/pages/Locations/Locations'
import AddLocations from '../../views/pages/Locations/AddLocations'
import Offers from '../../views/pages/Offers/Offers'
import AddOffers from '../../views/pages/Offers/AddOffers'
import Redemptions from '../../views/pages/Redemptions/Redemptions'
import Seeks from '../../views/pages/Seeks/Seeks'
import AppProducts from '../../views/pages/AppProducts/AppProducts'
import AddAppProducts from '../../views/pages/AppProducts/AddAppProducts'
import ShareClass from '../../views/pages/ShareClasses/shareClass'
import AddShareClass from '../../views/pages/ShareClasses/AddShareClass'
import NewDocumentsList from '../../views/pages/AllDocuments/NewDocuments'
import AddNewDocuments from '../../views/pages/AllDocuments/AddNewdocuments'
import Configurations from '../../views/pages/Configurations/Configurations'
import UpdateConfigurations from '../../views/pages/Configurations/UpdateConfigurations'
// import SentNotifications from '../../views/pages/SentNotifications/sentNotifications'
import NotificationsDetails from '../../views/pages/Notifications/NotificationsDetails'
import LoginHistory from '../../views/pages/UsersList/LoginHistory'
import ProductPerformance from '../../views/pages/ProductPerformance/ProductPerformance'
import AddProductPerformance from '../../views/pages/ProductPerformance/AddProductPerformance'
import FSTAssignments from '../../views/pages/FSTAssignments/FSTAssignments'
import FSTUsers from '../../views/pages/FSTUsers/FSTUsers'
import AddFSTUser from '../../views/pages/FSTUsers/AddFSTUser'
import AnalyticsLayout from '../../views/pages/AnalyticsUsage/AnalyticsLayout'
import AnalyticsUsageDashboard from '../../views/pages/AnalyticsUsage/AnalyticsUsageDashboard'
import AnalyticsConnectedUsers from '../../views/pages/AnalyticsUsage/AnalyticsConnectedUsers'
import AnalyticsUserDashboard from '../../views/pages/AnalyticsUsage/AnalyticsUserDashboard'
import AnalyticsGeoMap from '../../views/pages/AnalyticsUsage/AnalyticsGeoMap'
import AnalyticsDevices from '../../views/pages/AnalyticsUsage/AnalyticsDevices'
import ApiDocumentation from '../../views/pages/ApiDocumentation/ApiDocumentation'
import { getAccessToken, clearTokens } from '../../lib/utils/tokenUtils'
// import DocumentsNew from '../../views/pages/AllDocuments/NewDocuments'
// import AddDocumentsNew from '../../views/pages/AllDocuments/AddNewdocuments'
// import points from "../../views/pages/Points/points";
// import Points from "../../views/pages/Points/points";
// import Applications from "../../views/pages/ApplicationsPage/applications";
// import ApplicationsDetails from "../../views/pages/ApplicationsPage/applicationDetails";
// import Investments from "../../views/pages/Investments/investments";
// import InvestmentsDetails from "../../views/pages/Investments/investmentsDetails";

const AppContainer = () => {
  const token = getAccessToken()

  useEffect(() => {
    if (!token) {
      clearTokens()
      window.location.replace('/')
    }
  }, [token])

  // Do not mount any end-page (usersList, dashboard, …) without access token
  if (!token) {
    return null
  }

  const routingObjects = [
    {
      id: 0,
      path: 'dashboard',
      element: <Dashboard />
    },
    {
      id: 1,
      path: 'news',
      element: <News />
    },
    {
      id: 2,
      path: 'news_action/:id?',
      element: <Addnews />
    },
    {
      id: 3,
      path: "faqs/",
      element: <FAQ/>
    },
    {
      id: 4,
      path: "addFaqs/:id?",
      element: < AddFaqs/>
    },
    // {
    //   id: 5,
    //   path: "getInTouch",
    //   element: <GetInTouch/>,
    // },
    {
      id: 6,
      path: 'usersList',
      element: <UserList />
    },
    {
      id: 7,
      path: 'profileInfo/:id?',
      element: <ProfileInformation />
    },
    // {
    //   id: 8,
    //   path: "documents",
    //   element: < Documents/>,
    // },

    // {
    //   id: 9,
    //   path: "document_action/:id?",
    //   element: <AddDocuments />,
    // },

    {
      id: 10,
      path: 'userdetails/:id',
      element: <UserDetails />
    },
    // {
    //   id: 11,
    //   path: "getintouchdetails/:id",
    //   element: <SupportDetails/>,
    // },
    // {
    //   id: 12,
    //   path: "products",
    //   element: <Products/>,
    // },
    // {
    //   id: 13,
    //   path: "addproducts/:id?",
    //   element: <AddProducts/>,
    // },
    // {
    //   id: 14,
    //   path: "productdetails/:id",
    //   element: <ProductDetails/>,
    // },
    // {
    //   id: 15,
    //   path: "inviteFriend",
    //   element: <InviteFriend />,
    // },
    {
      id: 16,
      path: 'subscriptions',
      element: <Subscriptions />
    },
    {
      id: 17,
      path: 'subscriptionDetails/:id',
      element: <SubscriptionDetails />
    },
    // {
    //   id: 18,
    //   path: "applications",
    //   element: < Applications/>,
    // },
    // {
    //   id: 19,
    //   path: "applicationDetails/:id",
    //   element: <ApplicationsDetails/>,
    // },
    // {
    //   id: 20,
    //   path: "investments",
    //   element: < Investments/>,
    // },
    // {
    //   id: 21,
    //   path: "investmentDetails/:id",
    //   element: <InvestmentsDetails/>,
    // },
    {
      id: 22,
      path: 'brokers/',
      element: <Broker />
    },
    {
      id: 23,
      path: 'addBrokers',
      element: <AddBrokers />
    },
    {
      id: 23,
      path: 'Payments',
      element: <Payments />
    },
    {
      id: 24,
      path: 'Dashboard',
      element: <Dashboard />
    },
    {
      id: 25,
      path: 'Notifications',
      element: <NotificationList />
    },
    {
      id: 26,
      path: 'addNotifications',
      element: <AddNotification />
    },
    {
      id: 27,
      path: 'points',
      element: <Coins />
    },
    {
      id: 28,
      path: 'addPoints/:id?',
      element: <AddCoins />
    },
    {
      id: 29,
      path: 'dairies',
      element: <DatesDairies />
    },
    {
      id: 30,
      path: 'AddDairies/:id?',
      element: <AddDatesDairies />
    },
    {
      id: 31,
      path: 'category',
      element: <Category />
    },
    {
      id: 32,
      path: 'addCategory/:id?',
      element: <AddCategory />
    },
    {
      id: 33,
      path: 'locations',
      element: <Locations />
    },
    {
      id: 34,
      path: 'AddLocations/:id?',
      element: <AddLocations />
    },
    {
      id: 35,
      path: 'offers',
      element: <Offers />
    },
    {
      id: 36,
      path: 'addOffers/:id?',
      element: <AddOffers />
    },
    {
      id: 37,
      path: 'addOffers/:id?',
      element: <AddOffers />
    },
    {
      id: 38,
      path: 'redemptions',
      element: <Redemptions />
    },
    {
      id: 39,
      path: 'seeks',
      element: <Seeks />
    },
     {
      id: 40,
      path: 'prod_list',
      element: < AppProducts/>
    },
      {
      id: 41,
      path: 'AddProd_list/:id?',
      element: < AddAppProducts/>
    },
    {
      id: 42,
      path: 'shareclass',
      element: < ShareClass/>
    },
    {
      id: 43,
      path: 'AddShareclass/:id?',
      element: < AddShareClass/>
    },
     {
      id: 41,
      path: "documents-list",
      element: <NewDocumentsList/>,
    },

    {
      id: 42,
      path: "AddDocuments/:id?",
      element: <AddNewDocuments />,
    },
    {
      id: 43,
      path: "configurations",
      element: <Configurations />,
    },
    {
      id: 44,
      path: "edit-campiagn/:id",
      element: <UpdateConfigurations />,
    },
    // {
    //   id: 45,
    //   path: "sent-notifications",
    //   element: <SentNotifications />,
    // },
    {
      id: 46,
      path: "viewNotification/:id",
      element: <NotificationsDetails />,
    },
    {
      id: 47,
      path: "viewNotification/:id",
      element: <NotificationsDetails />,
    },
    {
      id: 48,
      path: "login_details/:id",
      element: <LoginHistory />,
    },
    {
      id: 49,
      path: "product_performance",
      element: <ProductPerformance />,
    },
    {
      id: 50,
      path: "Add_product_performance/:id?",
      element: <AddProductPerformance />,
    },
    {
      id: 51,
      path: 'fst-assignments',
      element: <FSTAssignments />
    },
    {
      id: 52,
      path: 'fst-users',
      element: <FSTUsers />
    },
    {
      id: 53,
      path: 'add-fst-user',
      element: <AddFSTUser />
    },
    {
      id: 55,
      path: 'analytics-usage',
      element: <AnalyticsLayout />,
      children: [
        { index: true, element: <AnalyticsUsageDashboard /> },
        { path: 'users', element: <AnalyticsConnectedUsers /> },
        { path: 'users/:userId', element: <AnalyticsUserDashboard /> },
        { path: 'map', element: <AnalyticsGeoMap /> },
        { path: 'devices', element: <AnalyticsDevices /> },
      ],
    },
    {
      id: 54,
      path: 'api-docs',
      element: <ApiDocumentation />
    },
    // {
    //   id: 55,
    //   path: 'email-list',
    //   element: <EmailList />
    // },
    // {
    //   id: 56,
    //   path: 'send-email',
    //   element: <AddEmail />
    // },
  ]

  const SidebarLayout = () => (
    <>
      <Header />
      <Sidebar />
      <Outlet />
    </>
  )
  const mobileResponsive = event => {
    const excludedHeader = document.querySelector('.header')
    const excludedSidebar = document.querySelector('.sidebar')

    if (
      !excludedHeader.contains(event.target) &&
      !excludedSidebar.contains(event.target)
    ) {
      document.body.classList.remove('slide-nav')
    }
  }

  return (
    <>
      <div className='main-wrapper' onClick={mobileResponsive}>
        <Routes>
          <Route path={'/*'} element={<SidebarLayout />}>
            {routingObjects.map(item =>
              item.children ? (
                <Route key={item.id} path={item.path} element={item.element}>
                  {item.children.map((child, idx) =>
                    child.index ? (
                      <Route key={`${item.id}-${idx}`} index element={child.element} />
                    ) : (
                      <Route key={`${item.id}-${idx}`} path={child.path} element={child.element} />
                    )
                  )}
                </Route>
              ) : (
                <Route key={item.id} path={item.path} element={item.element} />
              )
            )}
            <Route path='*' element={<Navigate to='/' replace />} />
          </Route>
        </Routes>
        {/* <SeachWindowPopup /> */}
      </div>
    </>
  )
}

export default AppContainer
